/**
 * @file        job/slice-payment-offer.js
 * @author      Ryan Rossiter, ryan@kingsds.network
 * @date        June 2020
 *
 * Convenience wrapper for creating SlicePaymentOffers
 *  The SlicePaymentOffer constructor can be passed any of:
 *  * a *magic* market value object, one returned from compute.marketValue
 *  * a fee structure shaped object, with either keys marketValue or maxPerRequest
 *  * a Number. MaxTotalPayment will be set to the number, maxPaymentPerSlice will be calculated dynamically
 */

const { BigNumber } = require('dcp/types');

class SlicePaymentOffer {
  constructor(paymentOffer) {
    this.marketValue = false;
    this.paymentOffer = null;

    const { MARKET_VALUE } = require('../compute');
    if (paymentOffer.hasOwnProperty(MARKET_VALUE)) {
      this.marketValue = paymentOffer[MARKET_VALUE];

    } else if (typeof paymentOffer === 'number') {
      this.paymentOffer = new BigNumber(paymentOffer);

    } else if (typeof paymentOffer === 'object' && paymentOffer !== null
      && (paymentOffer.hasOwnProperty('marketValue') || paymentOffer.hasOwnProperty('maxPerRequest'))) {
      this.marketValue = paymentOffer.hasOwnProperty('marketValue')? paymentOffer.marketValue : false;
      this.paymentOffer = paymentOffer.hasOwnProperty('maxPerRequest')? new BigNumber(paymentOffer.maxPerRequest) : null;
      
    } else {
      throw new Error("Payment offer must be a number, fee structure object, or a compute.marketValue object");
    }
  }

  /** Return a FeeStructure-shaped ES object representing this SlicePaymentOffer
   *  @param  maxSlices         The maximum number of slices to use when completing
   *                            unspecified fields
   */
  toFeeStructure (maxSlices) {
    if (!Number.isInteger(maxSlices) || maxSlices < 0) {
      throw new Error("SlicePaymentOffer.toFeeStructure: maxSlices argument must be greater than or equal to 0.");
    }
    
    if (!this.marketValue) {
      const maxTotal = this.paymentOffer.times(maxSlices);

      return {
        maxPerRequest: this.paymentOffer.toFixed(18, BigNumber.ROUND_DOWN),
        maxTotal: maxTotal.toFixed(18, BigNumber.ROUND_DOWN),
        maxRequests: maxSlices,
      }
    } else {
      return {
        marketValue: this.marketValue,
        maxRequests: maxSlices,
      }
    }
  }
}

Object.assign(exports, {
  SlicePaymentOffer,
});
